const o = ":host{display:block;font-family:var(--sl-font-family-base);font-size:var(--sl-font-size-sm)}.sl-breadcrumb{display:flex;flex-wrap:wrap;align-items:center;list-style:none;margin:0;padding:0;gap:var(--sl-breadcrumb-gap,var(--sl-spacing-2))}.sl-breadcrumb__item{display:flex;align-items:center;gap:var(--sl-breadcrumb-gap,var(--sl-spacing-2))}.sl-breadcrumb__link{color:var(--sl-breadcrumb-color,var(--sl-foreground));text-decoration:none;transition:color var(--sl-transition-fast) var(--sl-transition-timing-out)}.sl-breadcrumb__link:hover{color:hsl(var(--sl-hsl-primary));text-decoration:underline}.sl-breadcrumb__item--active .sl-breadcrumb__link{color:var(--sl-breadcrumb-active-color,var(--sl-foreground));font-weight:var(--sl-font-weight-medium);cursor:default;text-decoration:none}.sl-breadcrumb__separator{color:var(--sl-breadcrumb-separator-color,var(--sl-gray-400));user-select:none;font-size:var(--sl-font-size-sm)}";
class u extends HTMLElement {
  static get observedAttributes() {
    return ["separator", "ellipsis", "aria-label"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._list = document.createElement("ul"), this._render();
  }
  connectedCallback() {
    this._updateItems();
  }
  attributeChangedCallback(e, a, t) {
    a !== t && this._updateItems();
  }
  get separator() {
    return this.getAttribute("separator") || "/";
  }
  set separator(e) {
    this.setAttribute("separator", e);
  }
  get ellipsis() {
    return this.hasAttribute("ellipsis");
  }
  set ellipsis(e) {
    e ? this.setAttribute("ellipsis", "") : this.removeAttribute("ellipsis");
  }
  _updateItems() {
    const e = Array.from(this.querySelectorAll("sl-breadcrumb-item")), a = this.separator;
    this._list.innerHTML = "", e.forEach((t, c) => {
      if (c > 0) {
        const s = document.createElement("span");
        s.className = "sl-breadcrumb__separator", s.setAttribute("aria-hidden", "true"), s.textContent = a, this._list.appendChild(s);
      }
      const i = document.createElement("li"), l = t.hasAttribute("active");
      i.className = `sl-breadcrumb__item${l ? " sl-breadcrumb__item--active" : ""}`;
      const r = document.createElement("a");
      if (r.className = "sl-breadcrumb__link", t.hasAttribute("href")) {
        const s = t.getAttribute("href") ?? "";
        r.href = s, r.setAttribute("aria-current", l ? "page" : "");
      } else
        r.setAttribute("aria-current", "page");
      r.textContent = t.textContent || "", i.appendChild(r), this._list.appendChild(i);
    });
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${o}</style>
      <nav aria-label="${this.getAttribute("aria-label") || "Breadcrumb"}">
        <ul class="sl-breadcrumb"></ul>
      </nav>
    `, this._list = this._shadow.querySelector(".sl-breadcrumb");
  }
}
typeof customElements < "u" && !customElements.get("sl-breadcrumb") && customElements.define("sl-breadcrumb", u);
class b extends HTMLElement {
  static get observedAttributes() {
    return ["href", "active"];
  }
  constructor() {
    super();
  }
  attributeChangedCallback(e, a, t) {
    this.dispatchEvent(new Event("sl-breadcrumb-item-change", { bubbles: !0, composed: !0 }));
  }
  get href() {
    return this.getAttribute("href") || "";
  }
  set href(e) {
    this.setAttribute("href", e);
  }
  get active() {
    return this.hasAttribute("active");
  }
  set active(e) {
    e ? this.setAttribute("active", "") : this.removeAttribute("active");
  }
}
typeof customElements < "u" && !customElements.get("sl-breadcrumb-item") && customElements.define("sl-breadcrumb-item", b);
export {
  u as SlBreadcrumbElement,
  b as SlBreadcrumbItemElement
};
//# sourceMappingURL=sl-breadcrumb.js.map
